import React, { useState } from "react";
import "./Career.css";

import {
  FaWhatsapp,
  FaHandshake,
  FaIdCard,
  FaRoute,
  FaHeadset,
} from "react-icons/fa";

const careerOpportunities = [
  {
    title: "Business Partner",
    icon: <FaHandshake />,
    description:
      "Partner with Shreesha Tours & Travels and expand your business with regular travel bookings and long-term opportunities.",
    points: [
      "Corporate Travel Bookings",
      "Dedicated Business Support",
      "Transparent Payment System",
      "Long-Term Partnership",
    ],
  },

  {
    title: "Driver Partner",
    icon: <FaIdCard />,
    description:
      "Join our professional driver network and enjoy regular trips with attractive earning opportunities.",
    points: [
      "Flexible Working Hours",
      "Airport & Outstation Trips",
      "Weekly Incentive Programs",
      "Professional Driver Support",
    ],
  },

  {
    title: "Travel Consultant",
    icon: <FaRoute />,
    description:
      "Assist customers in planning local and outstation journeys while building a rewarding travel career.",
    points: [
      "Customer Travel Planning",
      "Booking Coordination",
      "Sales & Communication",
      "Career Advancement",
    ],
  },

  {
    title: "Customer Support",
    icon: <FaHeadset />,
    description:
      "Provide exceptional assistance to customers by handling bookings and resolving travel-related queries.",
    points: [
      "Customer Assistance",
      "Booking Management",
      "Driver Coordination",
      "Professional Work Environment",
    ],
  },
];

const Career = () => {

  const [formData, setFormData] = useState({
    name: "",
    phone: "",
    email: "",
    city: "",
    position: "",
    experience: "",
    message: "",
  });

  const handleChange = (e) => {

    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });

  };

  const handleSubmit = (e) => {

    e.preventDefault();

    const message = `*Shreesha Tours & Travels Career Application*

Name : ${formData.name}
Phone : ${formData.phone}
Email : ${formData.email}
City : ${formData.city}
Position : ${formData.position}
Experience : ${formData.experience}

Message :
${formData.message}`;

    window.open(
      `https://wa.me/919930929439?text=${encodeURIComponent(message)}`,
      "_blank"
    );

  };

  return (
    <>

      {/* Hero Section */}

   

      
 <section className="page-banner">
      <div className="page-banner-container">
        <h2>
          Career
        </h2>
      </div>
    </section>

      {/* Main Section */}

      <section className="career-section">

        <div className="container">

          <div className="row">

            {/* Left Form */}

      
            {/* Right Side */}

            <div className="col-lg-5">

              <div className="career-info">

                <h2>Current Openings</h2>

                <p>
                  Become a part of Shreesha Tours & Travels and build a
                  rewarding career in India's fast-growing travel and
                  transportation industry.
                </p>

                {careerOpportunities.map((job, index) => (

                  <div
                    className="career-card"
                    key={index}
                  >

                    <div className="career-icon">

                      {job.icon}

                    </div>

                    <div className="career-content">

                      <h4>{job.title}</h4>

                      <p>{job.description}</p>

                      <ul>

                        {job.points.map((point, i) => (

                          <li key={i}>

                            <i className="fas fa-check-circle"></i>

                            {point}

                          </li>

                        ))}

                      </ul>

                    </div>

                  </div>

                ))}

              </div>

            
            
            
            </div>
      <div className="col-lg-7">

              <div className="career-form">

                <h2>
                  Apply Now
                </h2>

                <p>
                  Complete the application form below and our HR team
                  will get in touch with you shortly.
                </p>

                <form onSubmit={handleSubmit}>

                  <div className="row">

                    <div className="col-md-6">

                      <input
                        type="text"
                        placeholder="Full Name"
                        name="name"
                        required
                        onChange={handleChange}
                      />

                    </div>

                    <div className="col-md-6">

                      <input
                        type="text"
                        placeholder="Mobile Number"
                        name="phone"
                        required
                        onChange={handleChange}
                      />

                    </div>

                    <div className="col-md-6">

                      <input
                        type="email"
                        placeholder="Email Address"
                        name="email"
                        required
                        onChange={handleChange}
                      />

                    </div>

                    <div className="col-md-6">

                      <input
                        type="text"
                        placeholder="Current City"
                        name="city"
                        required
                        onChange={handleChange}
                      />

                    </div>
                                        <div className="col-md-6">

                      <select
                        name="position"
                        required
                        onChange={handleChange}
                      >

                        <option value="">Select Position</option>

                        <option>Business Partner</option>

                        <option>Driver Partner</option>

                        <option>Travel Consultant</option>

                        <option>Customer Support Executive</option>

                      </select>

                    </div>

                    <div className="col-md-6">

                      <select
                        name="experience"
                        required
                        onChange={handleChange}
                      >

                        <option value="">Select Experience</option>

                        <option>Fresher</option>

                        <option>1 - 2 Years</option>

                        <option>3 - 5 Years</option>

                        <option>5+ Years</option>

                      </select>

                    </div>

                    <div className="col-12">

                      <textarea
                        rows="5"
                        name="message"
                        placeholder="Tell us about yourself..."
                        onChange={handleChange}
                      ></textarea>

                    </div>

                    <div className="col-12">

                      <button
                        type="submit"
                        className="career-btn"
                      >

                        <FaWhatsapp />

                        Submit Application

                      </button>

                    </div>

                  </div>

                </form>

              </div>

           
           
           <div className="career-contact">

  <h3>Contact HR</h3>

  <p className="career-contact-text">
    Have questions about career opportunities? Reach out to our HR team.
    We're happy to assist you with your application.
  </p>

 

  <div className="career-contact-item">

    <div className="career-contact-icon">
      <i className="fas fa-phone-alt"></i>
    </div>

    <div>

      <h5>Mobile Numbers</h5>

      <p>
        <a href="tel:+918355835813">+91 83558 35813</a><br/>
        <a href="tel:+919930929439">+91 99309 29439</a><br/>
        <a href="tel:+919022432779">+91 90224 32779</a>
      </p>

    </div>

  </div>

  <div className="career-contact-item">

    <div className="career-contact-icon">
      <i className="fas fa-envelope"></i>
    </div>

    <div>

      <h5>Email Address</h5>

      <p>
        <a href="mailto:booking@shreeshatravels.com">
          booking@shreeshatravels.com
        </a>
      </p>

    </div>

  </div>

 <div className="career-contact-item">

    <div className="career-contact-icon">
      <i className="fas fa-map-marker-alt"></i>
    </div>

    <div>

      <h5>Office Address</h5>

      <p>
        <strong>Shreesha Tours & Travels</strong><br/>
        Office 125, Saishraddha CHS,<br/>
        Plot No. 47, Near Koparkhairane Police Station,<br/>
        Sector 5, Sector 4, Ghansoli,<br/>
        Navi Mumbai, Maharashtra – 400701
      </p>

    </div>

  </div>

</div>
            </div>

          </div>

        </div>

      </section>

    </>

  );

};

export default Career;